import { render, staticRenderFns } from "./TheSnapshotTableColumns.vue?vue&type=template&id=5d0d6200&"
import script from "./TheSnapshotTableColumns.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotTableColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports